import React, { useEffect, useState } from 'react';
import './Observations.scss'

const ObservationDetails = (props) => {

    const { data } = props
    /** States */

    useEffect(()=> {
        console.log(data);
    },[])

    return (

        <div className='payload-observations'  >
            
            <div className='category'>
                <h4 className='category-name'>
                    {data.name}
                </h4>
                
                { 
                    data.decisions.map((decision, index) => {
                        return ( 
                            <span key={index} className='decision-name'>
                                {decision.decisions.map((answer)=>{
                                    return answer.choosed === true ? answer.answer : false
                                })}
                            </span>
                        )
                    })
                }
        
            </div>
        </div>
        
    )

}

export default ObservationDetails;